import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Stack, palette, useUtility, Text, Button } from '@hub-la/design-system';
import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined';
import ArrowForwardOutlined from '@mui/icons-material/ArrowForwardOutlined';
import { Avatar } from '@mui/material';

let _ = t => t,
  _t;
const AcountCardWrapper = styled(Stack)(_t || (_t = _`
  cursor: pointer;
  &:hover {
    background: ${0};
    border-color: ${0};
  }
`), palette('surfaceAt2'), palette('primary'));
const AccountCard = ({
  avatarUrl,
  name,
  email,
  loading,
  onClick
}) => {
  const {
    palette
  } = useUtility();
  return jsxs(AcountCardWrapper, Object.assign({
    direction: "row",
    alignItems: "center",
    border: 1.5,
    borderColor: palette('surfaceVariant'),
    p: 4,
    borderRadius: 4,
    justifyContent: "space-between",
    onClick: !loading ? onClick : undefined
  }, {
    children: [jsxs(Stack, Object.assign({
      direction: "row",
      gap: 4,
      alignItems: "center"
    }, {
      children: [jsx(Stack, {
        children: avatarUrl ? jsx(Avatar, {
          alt: "Remy Sharp",
          src: avatarUrl,
          sx: {
            width: 40,
            height: 40,
            border: 1,
            borderColor: palette('surfaceVariant')
          }
        }) : jsx(AccountCircleOutlined, {
          sx: {
            width: 40,
            height: 40,
            color: palette('onSurfaceVariant')
          }
        })
      }), jsxs(Stack, {
        children: [jsx(Text, Object.assign({
          variant: "body1",
          color: "onSurfaceVariant"
        }, {
          children: name
        })), jsx(Text, Object.assign({
          variant: "body1",
          color: "onSurfaceVariant"
        }, {
          children: email
        }))]
      })]
    })), jsx(Button, Object.assign({
      iconOnly: true,
      variant: "text",
      size: "small",
      loading: loading
    }, {
      children: jsx(ArrowForwardOutlined, {})
    }))]
  }));
};

export { AccountCard };
